export default "__VITE_ASSET__16e0f16f__"